import { Sparkles } from "lucide-react";
import { WorkspaceCard } from "../../components/userDashboard/ui/WorkspaceCard.jsx";
import { useEffect, useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { chatPageService } from "../../services/index.js";

export const WorkspaceSelector = () => {
  const [useCases, setUseCases] = useState([]);

  // ✅ get from Outlet (NOT props)
  const { setActiveUseCase } = useOutletContext();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUseCases = async () => {
      try {
        const data = await chatPageService.useCases();
        setUseCases(data?.data || []);
      } catch (error) {
        console.error("Error fetching use cases:", error);
        setUseCases([]);
      }
    };

    fetchUseCases();
  }, []);

  const handleSelect = (useCase) => {
    if (!setActiveUseCase) {
      console.error("setActiveUseCase is missing from context");
      return;
    }

    // ✅ set selected workspace
    setActiveUseCase(useCase);

    // ✅ navigate to chat
    navigate("/user/chat");
  };

  return (
    <div className="flex-1 h-full relative overflow-y-auto flex flex-col items-center justify-center">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-gradient-to-b from-white/55 via-white/20 to-transparent dark:from-slate-900/45 dark:via-slate-900/10 dark:to-transparent" />

      <div className="relative max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-10 py-8 sm:py-10">
        <div className="p-0 mb-6 flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-2xl bg-[#e8f7ec] dark:bg-slate-700 mb-5 flex items-center justify-center">
            <Sparkles size={28} className="text-[#36a852]" />
          </div>

          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-800 dark:text-white mb-2">
            Select your workspace
          </h1>

          <p className="text-slate-600 dark:text-slate-300 text-sm sm:text-base max-w-2xl">
            Choose a specialized use case to start your conversation with the right context.
          </p>

          <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-slate-200/80 dark:border-slate-600/70 bg-white/90 dark:bg-slate-800/70 px-3 py-1.5 text-xs font-semibold text-slate-600 dark:text-slate-300">
            <span className="w-2 h-2 rounded-full bg-[#36a852]" />
            {useCases.length} workspace{useCases.length === 1 ? "" : "s"} available
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
          {useCases.length > 0 ? (
            useCases.map((useCase, index) => (
              <WorkspaceCard
                key={index}
                useCase={useCase}
                onClick={() => handleSelect(useCase)}
              />
            ))
          ) : (
            <div className="col-span-full rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/40 p-8 text-center text-slate-500 dark:text-slate-400">
              No workspaces available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
